var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCategoryHotDogs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 151,
    viewBox: "0 0 151 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_343_7775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.7984 2.39545C75.0457 10.1975 57.4469 23.5096 40.3954 40.561C23.344 57.6125 10.0319 75.2116 2.22955 89.9643C-2.97074 99.7975 1.35837 114.897 12.6281 126.167C16.4757 130.014 21.7816 130.239 23.134 126.586C29.2157 110.158 44.746 87.8349 66.2075 66.3734C87.669 44.9119 109.992 29.3816 126.42 23.2996C130.073 21.9472 129.848 16.6413 126.001 12.7937C114.731 1.52427 99.6313 -2.80484 89.7984 2.39545Z",
    fill: "url(#paint0_linear_343_7775)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M71.735 23.0624C73.1042 23.0624 74.2141 21.9524 74.2141 20.5832C74.2141 19.2141 73.1042 18.1041 71.735 18.1041C70.3658 18.1041 69.2559 19.2141 69.2559 20.5832C69.2559 21.9524 70.3658 23.0624 71.735 23.0624Z",
    fill: "url(#paint1_linear_343_7775)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M72.6727 30.3774C73.7537 30.3774 74.63 29.501 74.63 28.42C74.63 27.339 73.7537 26.4626 72.6727 26.4626C71.5917 26.4626 70.7153 27.339 70.7153 28.42C70.7153 29.501 71.5917 30.3774 72.6727 30.3774Z",
    fill: "url(#paint2_linear_343_7775)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M80.0721 25.0468C80.7238 25.0468 81.2521 24.5185 81.2521 23.8668C81.2521 23.2151 80.7238 22.6868 80.0721 22.6868C79.4204 22.6868 78.8921 23.2151 78.8921 23.8668C78.8921 24.5185 79.4204 25.0468 80.0721 25.0468Z",
    fill: "url(#paint3_linear_343_7775)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M82.6621 14.9362C83.674 14.9362 84.4942 14.116 84.4942 13.1042C84.4942 12.0923 83.674 11.2721 82.6621 11.2721C81.6503 11.2721 80.8301 12.0923 80.8301 13.1042C80.8301 14.116 81.6503 14.9362 82.6621 14.9362Z",
    fill: "url(#paint4_linear_343_7775)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M78.808 18.9276C79.6067 18.9276 80.2542 18.2802 80.2542 17.4815C80.2542 16.6828 79.6067 16.0353 78.808 16.0353C78.0093 16.0353 77.3618 16.6828 77.3618 17.4815C77.3618 18.2802 78.0093 18.9276 78.808 18.9276Z",
    fill: "url(#paint5_linear_343_7775)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M84.9609 20.1853C85.4426 20.1853 85.833 19.7948 85.833 19.3132C85.833 18.8316 85.4426 18.4412 84.9609 18.4412C84.4793 18.4412 84.0889 18.8316 84.0889 19.3132C84.0889 19.7948 84.4793 20.1853 84.9609 20.1853Z",
    fill: "url(#paint6_linear_343_7775)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M9.28099 117.769C10.6151 114.504 11.1689 110.816 10.8172 106.918L10.7795 106.5C10.0145 98.0244 14.3001 91.1455 21.7545 88.8844L21.7601 88.8826C28.1281 86.9508 32.2628 81.6232 32.7901 74.6699L32.8404 74.0085C33.4219 66.3414 38.4351 60.747 45.8551 59.4843L46.4222 59.3879C53.2369 58.2282 58.0648 53.4014 59.2257 46.587L59.3231 46.0161C60.5872 38.5964 66.1825 33.584 73.8501 33.0032L74.6522 32.9423C81.5666 32.4185 86.8489 28.2805 88.7195 21.9223C90.9119 14.4702 97.7448 10.1705 106.184 10.9329L106.752 10.984C110.65 11.3361 114.337 10.7823 117.602 9.44846C122.163 7.58493 146.27 10.9029 78.5031 78.6702C10.7357 146.438 7.47217 122.196 9.28099 117.769Z",
    fill: "url(#paint7_linear_343_7775)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.563 8.21325C127.751 -1.59822 113.503 -1.78322 108.662 7.87237C99.6506 25.8471 84.7083 46.22 65.3809 65.5471C46.0536 84.8741 25.6806 99.8168 7.70623 108.828C-1.94935 113.669 -1.76436 127.918 8.04712 137.729C14.5992 144.281 23.6351 146.877 30.3801 144.106C50.2818 135.932 74.2021 119.373 96.7045 96.8706C119.207 74.3682 135.765 50.448 143.94 30.5462C146.71 23.8012 144.115 14.7653 137.563 8.21325Z",
    fill: "url(#paint8_linear_343_7775)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.94 30.5462C146.377 24.6118 144.66 16.905 139.75 10.6759L112.581 10.6891C112.55 10.6844 112.521 10.6765 112.489 10.6724C109.972 10.3427 107.665 12.1162 107.335 14.6327L105.811 26.2721C105.397 29.4271 103.16 31.3221 99.8256 31.3436L94.3912 31.3783C89.8003 37.875 84.618 44.4791 78.8968 51.0621L78.9891 54.3889C79.0903 58.038 76.9768 60.46 73.4759 60.7124L69.8518 60.9733C68.3879 62.503 66.8997 64.0286 65.3812 65.5471C59.8962 71.0321 54.3271 76.1627 48.7524 80.9062L47.2938 87.5077C46.9632 89.0033 46.1694 90.19 45.0024 90.9606L36.1479 90.9721C30.3591 95.2956 24.6306 99.1624 19.0497 102.539L14.9347 119.181C14.3256 121.644 15.8291 124.136 18.2932 124.746L64.0441 124.805C74.8591 117.029 85.9438 107.632 96.7047 96.8706C119.207 74.3683 135.765 50.448 143.94 30.5462Z",
    fill: "url(#paint9_linear_343_7775)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.443 134.931C28.3935 132.284 29.9488 129.596 30.9544 127.056L31.0624 126.784C33.2491 121.259 38.363 115.209 44.1586 111.289L44.163 111.286C49.1138 107.937 53.6297 102.991 56.2097 98.0897L56.455 97.6235C59.2997 92.2197 64.4986 86.8109 69.9518 83.5815L70.3685 83.3347C75.3771 80.3688 80.2047 75.5415 83.1712 70.5329L83.4197 70.1132C86.65 64.6597 92.0591 59.4612 97.463 56.6168L98.0283 56.3191C102.901 53.7538 107.818 49.2506 111.122 44.3259C114.994 38.5538 121.018 33.445 126.518 31.2682L126.888 31.1218C129.429 30.1165 132.116 28.5615 134.764 26.6109C138.463 23.8859 153.81 18.4438 86.0427 86.2112C18.2753 153.979 23.7983 138.522 26.443 134.931Z",
    fill: "url(#paint10_linear_343_7775)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1576 139.696C36.2208 149.76 50.2805 153.049 59.8658 147.601C74.2464 139.426 91.6158 125.885 108.667 108.833C125.719 91.782 139.26 74.4126 147.434 60.032C152.883 50.4467 149.593 36.387 139.53 26.3241C136.095 22.8885 131.085 22.9597 129.609 26.4891C122.974 42.3632 107.08 64.3232 85.6185 85.7847C64.157 107.246 42.197 123.14 26.3226 129.776C22.7932 131.251 22.722 136.261 26.1576 139.696Z",
    fill: "url(#paint11_linear_343_7775)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M43.2565 135.025C44.6256 135.025 45.7356 133.916 45.7356 132.546C45.7356 131.177 44.6256 130.067 43.2565 130.067C41.8873 130.067 40.7773 131.177 40.7773 132.546C40.7773 133.916 41.8873 135.025 43.2565 135.025Z",
    fill: "url(#paint12_linear_343_7775)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M38.6532 140.915C39.7342 140.915 40.6105 140.038 40.6105 138.957C40.6105 137.876 39.7342 137 38.6532 137C37.5721 137 36.6958 137.876 36.6958 138.957C36.6958 140.038 37.5721 140.915 38.6532 140.915Z",
    fill: "url(#paint13_linear_343_7775)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M47.1844 141.78C47.8361 141.78 48.3644 141.251 48.3644 140.6C48.3644 139.948 47.8361 139.42 47.1844 139.42C46.5327 139.42 46.0044 139.948 46.0044 140.6C46.0044 141.251 46.5327 141.78 47.1844 141.78Z",
    fill: "url(#paint14_linear_343_7775)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M135.588 48.7847C136.958 48.7847 138.068 47.6747 138.068 46.3055C138.068 44.9364 136.958 43.8264 135.588 43.8264C134.219 43.8264 133.109 44.9364 133.109 46.3055C133.109 47.6747 134.219 48.7847 135.588 48.7847Z",
    fill: "url(#paint15_linear_343_7775)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M130.985 54.6741C132.066 54.6741 132.943 53.7978 132.943 52.7168C132.943 51.6357 132.066 50.7594 130.985 50.7594C129.904 50.7594 129.028 51.6357 129.028 52.7168C129.028 53.7978 129.904 54.6741 130.985 54.6741Z",
    fill: "url(#paint16_linear_343_7775)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M139.516 55.5391C140.168 55.5391 140.696 55.0108 140.696 54.3591C140.696 53.7074 140.168 53.1791 139.516 53.1791C138.865 53.1791 138.336 53.7074 138.336 54.3591C138.336 55.0108 138.865 55.5391 139.516 55.5391Z",
    fill: "url(#paint17_linear_343_7775)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M56.3653 136.247C57.3771 136.247 58.1973 135.426 58.1973 134.415C58.1973 133.403 57.3771 132.583 56.3653 132.583C55.3534 132.583 54.5332 133.403 54.5332 134.415C54.5332 135.426 55.3534 136.247 56.3653 136.247Z",
    fill: "url(#paint18_linear_343_7775)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M50.5668 136.484C51.3655 136.484 52.013 135.837 52.013 135.038C52.013 134.239 51.3655 133.592 50.5668 133.592C49.7681 133.592 49.1206 134.239 49.1206 135.038C49.1206 135.837 49.7681 136.484 50.5668 136.484Z",
    fill: "url(#paint19_linear_343_7775)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M53.8657 141.418C54.3473 141.418 54.7378 141.027 54.7378 140.546C54.7378 140.064 54.3473 139.674 53.8657 139.674C53.3841 139.674 52.9937 140.064 52.9937 140.546C52.9937 141.027 53.3841 141.418 53.8657 141.418Z",
    fill: "url(#paint20_linear_343_7775)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M35.7729 146.719C44.0424 150.93 53.0765 151.46 59.8662 147.601C74.2468 139.427 91.6162 125.885 108.668 108.834C125.719 91.7821 139.261 74.4127 147.435 60.0321C151.294 53.2424 150.764 44.208 146.553 35.9388L35.7729 146.719Z",
    fill: "url(#paint21_linear_343_7775)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.82 65.5747C81.3656 68.0294 78.0156 69.6011 74.1359 69.8805L64.8168 70.5514C61.9991 70.7541 60.0515 72.3714 59.4732 74.9888L56.2691 89.4905C55.3812 93.5079 53.0156 96.8605 49.6094 98.9291C45.8574 101.207 41.1879 101.765 36.4615 100.498C34.2121 99.895 32.1029 100.077 30.5224 101.01C29.2765 101.745 28.4212 102.933 28.0474 104.445L23.8579 121.387C23.2491 123.851 20.7574 125.355 18.2932 124.746C15.8291 124.136 14.3256 121.645 14.9347 119.181L19.1238 102.239C20.09 98.3317 22.4785 95.0838 25.8494 93.0941C29.5735 90.8955 34.1874 90.3717 38.8409 91.6191C41.1209 92.2299 43.2509 92.0358 44.8379 91.072C46.0976 90.3067 46.9474 89.0738 47.2935 87.5073L50.4976 73.0055C51.9485 66.4382 57.31 61.8758 64.1565 61.3829L73.4753 60.712C76.9762 60.4599 79.0897 58.0376 78.9885 54.3885L78.7885 47.1708C78.6676 42.8117 80.1488 38.8094 82.9597 35.9014C85.7397 33.0126 89.6597 31.4076 93.9662 31.3805L99.825 31.3429C103.159 31.3214 105.396 29.4264 105.81 26.2714L107.335 14.632C107.664 12.1155 109.972 10.3423 112.489 10.6717C115.006 11.0014 116.779 13.3091 116.449 15.8258L114.924 27.4655C113.923 35.1102 107.738 40.4849 99.8835 40.5347L94.0244 40.572C92.1838 40.5835 90.6371 41.1941 89.5688 42.2891C88.4747 43.4211 87.9241 45.0211 87.9768 46.9158L88.1768 54.1335C88.3038 58.7061 86.6618 62.732 83.82 65.5747Z",
    fill: "url(#paint22_linear_343_7775)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_343_7775",
    x1: 44.2619,
    y1: 44.4347,
    x2: 56.5423,
    y2: 56.7151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2061,
    stopColor: "#FBA682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#FDA861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA936"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_343_7775",
    x1: 75.2915,
    y1: 21.6009,
    x2: 63.9511,
    y2: 18.5962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_343_7775",
    x1: 75.4628,
    y1: 29.2317,
    x2: 66.5102,
    y2: 26.8599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_343_7775",
    x1: 81.7158,
    y1: 24.375,
    x2: 76.3183,
    y2: 22.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_343_7775",
    x1: 83.9872,
    y1: 15.6876,
    x2: 80.0585,
    y2: 7.95843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_343_7775",
    x1: 79.8658,
    y1: 19.54,
    x2: 76.7642,
    y2: 13.4378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_343_7775",
    x1: 85.6217,
    y1: 20.5943,
    x2: 83.7517,
    y2: 16.9156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_343_7775",
    x1: 55.9966,
    y1: 56.1296,
    x2: 68.7178,
    y2: 68.8509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_343_7775",
    x1: 67.2613,
    y1: 67.4344,
    x2: 90.2492,
    y2: 90.4223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_343_7775",
    x1: 96.8403,
    y1: 82.6289,
    x2: 71.7116,
    y2: 62.0059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_343_7775",
    x1: 79.2298,
    y1: 79.363,
    x2: 87.8849,
    y2: 88.0181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_343_7775",
    x1: 82.2883,
    y1: 83.2005,
    x2: 125.153,
    y2: 108.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2061,
    stopColor: "#FBA682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#FDA861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA936"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_343_7775",
    x1: 45.4193,
    y1: 135.627,
    x2: 39.0846,
    y2: 125.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_343_7775",
    x1: 40.3854,
    y1: 141.373,
    x2: 35.3847,
    y2: 133.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_343_7775",
    x1: 48.2825,
    y1: 142.018,
    x2: 45.2675,
    y2: 137.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_343_7775",
    x1: 137.789,
    y1: 49.3324,
    x2: 131.455,
    y2: 39.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_343_7775",
    x1: 132.755,
    y1: 55.0778,
    x2: 127.754,
    y2: 47.2737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_343_7775",
    x1: 140.652,
    y1: 55.7233,
    x2: 137.637,
    y2: 51.0184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_343_7775",
    x1: 55.7191,
    y1: 137.039,
    x2: 58.041,
    y2: 128.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_343_7775",
    x1: 50.0762,
    y1: 137.098,
    x2: 51.9096,
    y2: 130.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_343_7775",
    x1: 53.6113,
    y1: 141.764,
    x2: 54.7163,
    y2: 137.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_343_7775",
    x1: 96.5705,
    y1: 96.7433,
    x2: 115.073,
    y2: 115.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_343_7775",
    x1: 58.0728,
    y1: 60.1922,
    x2: 73.6176,
    y2: 75.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_343_7775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(0.0454102 0.211426)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCategoryHotDogs);
export default __webpack_public_path__ + "static/media/icon-category-hot-dogs.702e4df0.svg";
export { ForwardRef as ReactComponent };